<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="action-bar">
        <input 
          type="text" 
          class="form-control search-input" 
          placeholder="Search by Vehicle No..." 
          v-model="searchQuery" 
        />
        <button type="button" class="btn button-default new-item-btn" @click="newVehicle">
          Create Vehicle
        </button>
      </div>

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <table v-else class="table">
        <thead>
          <tr class="border-bottom-primary">
            <th scope="col">Vehicle Type</th>
            <th scope="col">Vehicle No</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vehicle in filteredVehicles" :key="vehicle.id">
            <td>{{ vehicle.vehicle_type }}</td>
            <td>{{ vehicle.vehicle_no }}</td>
            <td>
              <span :class="vehicle.is_active === '1' ? 'badge badge-active' : 'badge badge-cancel'">
                {{ vehicle.is_active === '1' ? 'ACTIVE' : 'INACTIVE' }}
              </span>
            </td>
            <td>
              <i class="fa fa-edit" @click="editVehicle(vehicle.id)"></i>
            </td>
          </tr>

          <tr v-if="!filteredVehicles.length">
            <td colspan="4" class="text-center no-data">No vehicles found.</td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { fetchAllVehiclesList } from "@/services/dataService";

export default {
  data() {
    return {
      token: localStorage.getItem('token_set'),
      companyId: localStorage.getItem('company_id'),
      profileId: localStorage.getItem('profile_id'),
      reportingProfileId: localStorage.getItem('reportingL1ProfileId'),
      userCategory: localStorage.getItem('user_label'),

      router: useRouter(),
      loading: false,
      vehiclesList: [],
      searchQuery: "",
    }
  },

  computed: {
    filteredVehicles() {
      if (!this.searchQuery) {
        return this.vehiclesList;
      }
      const query = this.searchQuery.toLowerCase();
      return this.vehiclesList.filter(vehicle => 
        (vehicle.vehicle_no || "").toLowerCase().includes(query)
      );
    }
  },

  created() {
    this.fetchVehicles();
  },

  methods: {
    async fetchVehicles() {
      this.loading = true;
      try {
        let idToUse = this.profileId;
        if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
          idToUse = this.reportingProfileId;
        }
        const response = await fetchAllVehiclesList(idToUse, this.token);
        this.vehiclesList = response.data.data || [];
      } catch (error) {
        console.error("Error fetching vehicle list:", error);
        this.vehiclesList = [];
      } finally {
        this.loading = false;
      }
    },

    newVehicle() {
      this.$router.push({ path: "/new-vehicle" });
    },

    editVehicle(id) {
      this.router.push({ path: `/edit-vehicle/${id}` });
    },
  }
}
</script>

<style scoped lang="scss">
.card {
  padding: 10px;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

.search-input {
  max-width: 300px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 100%;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.new-item-btn {
  margin: 0;
  padding: 10px 20px;
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-edit:active {
  transform: scale(1.1);
}

.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 80px;
  max-width: 80px;
}

.badge-active {
  background-color: #28a745;
}

.badge-cancel {
  background-color: #dc3545;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  color: #007bff;
}

.no-data {
  color: #888;
  padding: 20px 0;
}
</style>